export default "__VITE_ASSET__0e871fdc__"